(() => {
  if (customElements.get('az-brand-ticker')) return;
  customElements.define('az-brand-ticker', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const opts = { signal:this.abort.signal };
      this.bar = this.querySelector('.az-ticker__bar');
      this.viewport = this.querySelector('.az-ticker__viewport');
      this.track = this.querySelector('.az-ticker__track');
      this.list = this.querySelector('.az-ticker__list');
      this.toggle = this.querySelector('.az-ticker__toggle');
      if (!this.list) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true; this.hovered = false; this.focused = false; this.paused = false;
      this.toggle.setAttribute('aria-pressed','false');
      this.toggle.setAttribute('aria-label',this.dataset.pauseLabel);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.setAttribute('aria-pressed',String(this.paused));
        this.toggle.setAttribute('aria-label',this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.sync();
      }, opts);
      this.bar.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.sync(); } },opts);
      this.bar.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); },opts);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); },opts);
      this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.sync(); },opts);
      document.addEventListener('visibilitychange', () => this.sync(),opts);
      this.reduced.addEventListener('change', () => this.rebuild(),opts);
      this.addEventListener('shopify:block:select', e => {
        e.target.scrollIntoView({block:'nearest',inline:'center'});
      },opts);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.rebuild());
        this.resize.observe(this.viewport); this.resize.observe(this.list);
      }
      this.rebuild();
    }
    rebuild() {
      this.animation?.cancel(); this.animation = null;
      this.track.querySelectorAll('[data-trust-copy]').forEach(el => el.remove());
      this.dataset.running = 'false';
      if (this.dataset.motion !== 'true' || this.reduced.matches || window.Shopify?.designMode || !this.track.animate) return;
      const width = this.list.getBoundingClientRect().width;
      if (!width || !this.viewport.clientWidth) return;
      this.dataset.running = 'true';
      this.viewport.scrollLeft = 0;
      const copies = Math.ceil(this.viewport.clientWidth / width) + 1;
      for (let i=0;i<copies;i++) {
        const copy = this.list.cloneNode(true);
        copy.setAttribute('data-trust-copy',''); copy.setAttribute('aria-hidden','true'); copy.inert = true;
        copy.querySelectorAll('*').forEach(el => {
          [...el.attributes].filter(a => a.name === 'id' || a.name.startsWith('data-shopify') || a.name === 'data-block-id').forEach(a => el.removeAttribute(a.name));
        });
        this.track.append(copy);
      }
      const reverse = this.dataset.direction === 'right';
      this.animation = this.track.animate([
        {transform:`translateX(${reverse ? -width : 0}px)`},
        {transform:`translateX(${reverse ? 0 : -width}px)`}
      ], {duration:width / Math.max(5,Number(this.dataset.speed) || 25) * 1000,iterations:Infinity,easing:'linear'});
      this.sync();
    }
    sync() {
      if (!this.animation) return;
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden) this.animation.pause();
      else this.animation.play();
    }
    cleanup() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.animation?.cancel();
      this.track?.querySelectorAll('[data-trust-copy]').forEach(el => el.remove());
    }
    disconnectedCallback() { this.cleanup(); }
  });
})();
